import { render } from "./NavTab.vue?vue&type=template&id=448e7a1e&scoped=true&ts=true"
import script from "./NavTab.vue?vue&type=script&lang=ts"
export * from "./NavTab.vue?vue&type=script&lang=ts"

import "./NavTab.vue?vue&type=style&index=0&id=448e7a1e&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448e7a1e"]])

export default __exports__